import React from "react";

const BenefitCard = (props) => {

  const { title, benefits } = props;

  return (
    <>

      <div className="col-md-12 col-lg-6">
        <div className="flex-card">
          <div className="content-block">
            <div className="pro-details">
              <div className="left-blk">
                <h4>
                  {title}
                </h4>
                <ul className="career-page-list">
                  {benefits.map((item, index) => {
                    return (
                      <li key={index}>
                        <span>
                          <i className="fa-solid fa-circle-check"></i>
                        </span>
                        {item}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BenefitCard;
